import React from "react";
import HealthCampFormPage from "../components/health-camps/HealthCampFormPage";

const HealthCampCreate = () => <HealthCampFormPage mode="create" />;

export default HealthCampCreate;
